export default __webpack_public_path__ + "static/media/Abyssal Demon Ring of Dexterity.10396de1.jpg";